import { jsx as _jsx } from "react/jsx-runtime";
import { useThemeConfig } from "../themeConfigContext";
import { GridSection } from "./gridSection";
var BUTTON_VARIANTS = [
    { key: "PRIMARY", title: "Primary button" },
    { key: "SECONDARY", title: "Secondary button" },
    { key: "INFO", title: "Info button" },
    { key: "SUCCESS", title: "Success button" },
    { key: "WARNING", title: "Warning button" },
    { key: "DANGER", title: "Danger button" },
];
export default function ButtonStylesSection(_a) {
    var t = useThemeConfig().t;
    var rows = BUTTON_VARIANTS.map(function (_a) {
        var key = _a.key, title = _a.title;
        return [
            {
                title: title,
                label: t("app.LBL_".concat(key, "_BUTTON"), { ns: "common" }) || title,
                margin: true,
                padding: true,
                border: true,
            },
            {
                title: "".concat(title, " hover"),
                label: t("app.LBL_".concat(key, "_BUTTON_HOVER"), { ns: "common" }) || "".concat(title, " hover"),
            },
        ];
    });
    return _jsx(GridSection, { rows: rows });
}
